import React, { PropsWithChildren, ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import { Svg } from 'ui'

export default function FeaturesContainer({
  children,
  sx,
}: PropsWithChildren<{
  sx?: ThemeUIStyleObject
}>): ReactElement {
  return (
    <Flex
      sx={{
        maxWidth: '102.2rem',
        gap: '1.6rem',
        mt: ['4rem', '8rem'],
        mb: '8rem',
        flexWrap: 'wrap',
        px: ['1.6rem', 0],
        justifyContent: 'center',
        ...sx,
      }}
    >
      {children}
    </Flex>
  )
}

export function FeatureItem({
  svg,
  title,
  description,
  sx,
}: {
  svg: React.ElementType
  title: string
  description: string | ReactElement
  sx?: ThemeUIStyleObject
}): ReactElement {
  return (
    <Flex
      sx={{
        width: ['100%', '50.3rem'],
        p: '2.4rem',
        flexDirection: 'column',
        gap: '0.8rem',
        borderRadius: '1.2rem',
        backgroundColor: 'eerieBlack3',
        ...sx,
      }}
    >
      <Svg svg={svg} descriptiveText="feature icon" />
      <Text variant="size15Weight600Line138Letter03" sx={{ color: 'aliceBlue' }}>
        {title}
      </Text>
      <Text variant="size14Weight400Line138Letter028" sx={{ color: 'lightSteelBlue' }}>
        {description}
      </Text>
    </Flex>
  )
}
